

















































import Vue from "vue";
import permission, { PermissionName } from "@/common/mixins/permission";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import { MarketplaceStopSyncSchedule } from "../models/MarketplaceStopSyncSchedule";

export default Vue.extend({
  mixins: [permission, pagination],
  data() {
    const schedules: MarketplaceStopSyncSchedule[] = [];

    return {
      schedules
    };
  },
  computed: {
    hasMarketplaceStopSyncPermission() {
      return (this as any).hasPermission(PermissionName.MARKETPLACE_STOP_SYNC);
    }
  },
  async created() {
    (this as any).getPaginationRouteQuery();
    await Promise.all([this.getMarketplaceStopSyncs()]);
  },
  methods: {
    async getMarketplaceStopSyncs() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage
      };

      try {
        const {
          data,
          meta
        } = await (this as any).$dep.marketplaceUseCase.getMarketplaceStopSyncs(
          form
        );

        this.schedules = data;
        (this as any).setPaginationMeta(meta);
      } catch (error) {
        console.log(error.response);
      }
    },
    goToMarketplaceStopSyncCreatePage() {
      this.$router.push({ name: "MarketplaceStopSyncCreatePage" });
    }
  }
});
